var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("icon-view", {
              attrs: {
                icon: _vm.icon,
                "icon-background": _vm.iconColor,
                "icon-color": "#fff",
                variant: "custom-icon",
                width: "w-auto"
              }
            }),
            _c("div", { staticClass: "color-black font-weight-bold font-20" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v("Total de Servicios:")
          ]),
          _c("div", { staticClass: "color-black font-weight-bold font-25" }, [
            _vm._v(" " + _vm._s(_vm.serviceTotal) + " ")
          ])
        ])
      ]),
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v("Monto Total:")
          ]),
          _c("div", { staticClass: "color-black font-weight-bold font-25" }, [
            _vm._v(" " + _vm._s(_vm.amount) + " ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }